import React, { useState, useRef, useEffect } from "react";

interface ErrorTooltipProps {
  message: string;
  children: React.ReactNode;
  align?: "center" | "left" | "right" | "auto";
}

const U2000ErrorTooltip: React.FC<ErrorTooltipProps> = ({ message, children, align = "auto" }) => {
  const [show, setShow] = useState(false);
  const [autoAlign, setAutoAlign] = useState<"center" | "left" | "right">("center");
  const parentRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (align !== "auto" || !show || !parentRef.current) return;
    const rect = parentRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    // 120 = tooltip width approx, can be adjusted or measured
    if (rect.left < 60) setAutoAlign("left");
    else if (rect.right > vw - 60) setAutoAlign("right");
    else setAutoAlign("center");
  }, [align, show]);

  const effectiveAlign = align === "auto" ? autoAlign : align;

  let tooltipClass = "absolute z-50 top-full mt-2 px-3 py-1 rounded-sm bg-red-600 text-white text-xs whitespace-nowrap shadow-lg animate-fade-in";
  if (effectiveAlign === "center") {
    tooltipClass += " left-1/2 -translate-x-1/2";
  } else if (effectiveAlign === "left") {
    tooltipClass += " left-0";
  } else if (effectiveAlign === "right") {
    tooltipClass += " right-0";
  }

  return (
    <span
      ref={parentRef}
      className="relative inline-block"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
      tabIndex={0}
    >
      {children}
      {show && <span className={tooltipClass}>{message}</span>}
    </span>
  );
};

export default U2000ErrorTooltip;
